
define(
	'Code25.payment'
	, [
		"underscore", "jQuery", "Profile.Model", "Tools", "Utils"
	]
	, function (
		_, jQuery, ProfileModel, Tools, Utils
	) {
		'use strict';

		return {
			mount: function (container) {

				var OrderWizardModulePaymentMethodSelector = require("OrderWizard.Module.PaymentMethod.Selector");

				_.extend(OrderWizardModulePaymentMethodSelector.prototype, {

					getContext: _.wrap(OrderWizardModulePaymentMethodSelector.prototype.getContext, function (getContext) {

						var custentity_credit_hold_override = Tools.getProfileValue("custentity_credit_hold_override");
						// console.log("custentity_credit_hold_override",custentity_credit_hold_override+" "+(typeof custentity_credit_hold_override));

						if (custentity_credit_hold_override == "2") {
							for (var i = this.modules.length - 1; i >= 0; i--) {
								if (this.modules[i].type == "creditcard") {
									this.modules[i].isSelected = true;
									this.selectedModule = this.modules[i];
								} else if (this.modules[i].type != "paypal") {
									this.modules[i].isSelected = false;
									this.modules.splice(i, 1);
								}
							}
						}

						var res = getContext.apply(this, _.rest(arguments));
						res.creditHold=custentity_credit_hold_override == "2";

						return res;

					})
				});

			}
		};

	});
